import {COLORS} from 'frontend/utils/color_palettes';
import {fuseSVG} from 'frontend/utils/icons';

import {AssetMapMarkerData, DefaultMapMarker, IconSize} from './default';

const FUSE_COLOR = COLORS.NewPrimary.get(40);

export interface FuseMapMarkerData extends AssetMapMarkerData {
  color?: string;
}

/**
 * A map marker for a fuse asset.
 */
export class FuseMapMarker extends DefaultMapMarker<FuseMapMarkerData> {
  protected override getDefaultIcon(size: IconSize): string {
    return fuseSVG(this.data?.color ?? FUSE_COLOR, size);
  }
}
